import React, { Suspense, useContext, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "../components/context/AuthContext2";
import { Context } from "../components/context/Store";
import { ModalProvider } from "../ModalContext";
import PageLoader from "../components/general/helpers/page-loader";

const MainRouter = React.lazy(() => import('../components/routing/routers1/MainRouter'));
const Maintenance = React.lazy(() => import('../components/general/auth-hoc/Maintenance'));

function AuthRouters() {
	const { dispatch } = useContext(Context);

	useEffect(() => {
        let user_data = localStorage.getItem("user_data");
        try {
            user_data = JSON.parse(user_data);
        } catch {
            user_data = null;
        }
		dispatch({ type: "UPDATE_USER_DATA", user_data: user_data });
	}, [dispatch]);

    return (
        <Suspense fallback={<PageLoader />}>
            <Router>
                <div className="flex flex-col min-h-screen">
                    <AuthProvider>
                        <ModalProvider>
                            <Routes>
                                <Route path='/maintenance' element={<Maintenance />} />
                                <Route path='/*' element={<MainRouter />} />
                            </Routes>
                        </ModalProvider>
                    </AuthProvider>
                </div>
            </Router>
        </Suspense>
    );
}

export default AuthRouters;
